import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import FormChecker from 'src/app/core/utils/form-checker';
import { CustomInput } from '../CustomInput';

@Component({
  selector: 'app-input-email',
  templateUrl: './input-email.component.html',
  styleUrls: ['./input-email.component.scss'],
})
export class InputEmailComponent extends CustomInput {
  @Input() label = 'E-mail';
  @Input() icon: string | undefined;

  override control = new UntypedFormControl(null, FormChecker.email);
  override errorList = ['invalidEmail'];
}
